import { useEffect, useState } from "react"

// Collapsed sections keep their rows mounted only for the length of the
// close transition. Rendering every article of every group up front costs a
// Zero subscription, a dnd-kit droppable and a ResizeObserver per row, which
// is what made a large help center unusable.
export function useDelayedUnmount(isOpen: boolean, delayMs: number) {
	const [isMounted, setIsMounted] = useState(isOpen)

	useEffect(() => {
		if (isOpen) {
			setIsMounted(true)
			return
		}
		const timer = window.setTimeout(() => setIsMounted(false), delayMs)
		return () => window.clearTimeout(timer)
	}, [isOpen, delayMs])

	return isOpen || isMounted
}
